const isContentfulPage = (pageClass) => typeof pageClass.pageName === 'string';

export default isContentfulPage;
